module.exports = __webpack_public_path__ + "static/img/short3.1cd7138.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/short3.png
// module id = 88vW
// module chunks = 1